import { render, staticRenderFns } from "./FafMultiselect.vue?vue&type=template&id=b02f8598&"
import script from "./FafMultiselect.vue?vue&type=script&lang=js&"
export * from "./FafMultiselect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports